import { Button } from "@/components/ui/atoms/Button/Button"
import SliderWithLabel from "@/components/ui/molecules/SliderWithLabel/SliderWithLabel"
import AdminSettingsDisplayStandby from "./AdminSettingsDisplayStandby"
import ButtonGroupYesNoWithLabel from "@/components/ui/molecules/ButtonGroupYesNoWithLabel/ButtonGroupYesNoWithLabel"
import { DisplaySettings } from "@/types/settings.types"
import { SelectInterfaceOption } from "./AdminSettingsDisplaySelectInterface"

type AdminSettingsDisplayHomeProps = {
  interfaceOptions: SelectInterfaceOption[];
  themeOptions: SelectInterfaceOption[];
  settings: DisplaySettings;
  updateDisplaySettings: (settings: DisplaySettings) => void;
  changeStep: (newStep: string) => void;
}

const AdminSettingsDisplayHome = ({ interfaceOptions, themeOptions, settings, updateDisplaySettings, changeStep }: AdminSettingsDisplayHomeProps) => {
  
  return (
    <>
      <h2 className="text-header3 text-white p-2w bg-admin-darkblue-300">Affichage & Diaporama</h2>
      <div className="flex flex-col gap-4w p-2w m-2w rounded-2xl bg-white">
        {/* <div className="flex flex-col gap-2w md:flex-row md:items-center md:justify-between">
          <div className="flex flex-col gap-2w md:flex-row md:items-center md:gap-4w">
            <span className='text-body1'>Choix du mode d’affichage de la page d’accueil</span>
            <span className='text-body1 text-admin-blue-300'>Affichage actuel : {interfaceOptions.find(option => settings?.interfaceMode === option.value)?.title}</span>
          </div>
          <Button onClick={() => changeStep('displayMode')}>MODIFIER</Button>
        </div>
        <div className="flex flex-col gap-2w md:flex-row md:items-center md:justify-between">
          <div className="flex flex-col gap-2w md:flex-row md:items-center md:gap-4w">
            <span className='text-body1'>Choix d’un thème Ardoiz</span>
            <span className='text-body1 text-admin-blue-300'>Thème actuel : {themeOptions.find(option => settings?.theme === option.value)?.title}</span>
          </div>
          <Button onClick={() => changeStep('displayTheme')}>MODIFIER</Button>
        </div> */}
        <SliderWithLabel
          label="Luminosité"
          disabled
          value={[Math.round((settings?.screenBrightness * 100) / 255)]}
          onChange={(value) => updateDisplaySettings({screenBrightness: (value[0] * 255) / 100})}
        />
        <AdminSettingsDisplayStandby
          value={settings?.standByDelay}
          onChange={(value) => updateDisplaySettings({standByDelay: value})}
        />
        {/* <ButtonGroupYesNoWithLabel
          label="Afficher le diaporama lorsque la tablette est en charge"
          value={settings?.screenLock}
          onChange={(value) => updateDisplaySettings({screenLock: value})}
        /> */}
      </div>
    </>
  )
}

export default AdminSettingsDisplayHome;